<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>合同管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-form inline label-position="right" label-width="60px" size="small" class="query-form" :v-model="query"
        @submit.native.prevent="getList();">
        <el-form-item label="搜索" prop="name">
          <el-input v-model="key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selList();">查询</el-button>
          <el-button type="success" @click="dialogVisible = true; form = { isEnable: true,projectID:projectid };">新增</el-button>
        </el-form-item>
      </el-form>
      <!-- 列表查询 -->
      <el-card class="box-card table">
        <div slot="header" class="clearfix">
          <span>合同列表</span>
        </div>
        <!-- 列表定义 -->
        <el-table v-loading="loading" :data="tableData" ref="tableData" border stripe style="width:100%;">
          <el-table-column prop="projectName" label="项目名称"></el-table-column>
          <el-table-column prop="title" label="合同名称"></el-table-column>
          <el-table-column prop="createTime" label="上传时间"></el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip content="下载" placement="top">
                  <el-link :href="'/project/download?id=' + scope.row.id" target="_blank"
                    style="dispaly:inline-blick;float:left;border-right-color: rgba(255,255,255,.5);">
                    <el-button type="success" size="mini" icon="el-icon-download"></el-button>
                  </el-link>
                </el-tooltip>
                <el-tooltip content="删除" placement="top">
                  <el-button type="danger" size="mini" icon="el-icon-delete" @click="delClick(scope.row)"></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页条 -->
        <div class="block" style="margin-top:20px;">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage4" :page-sizes="[10, 20, 30, 50, 100]" :page-size="pageSize"
            layout="total, sizes,prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 操作对话框 -->
    <el-dialog :title="form.id > 0 ? '编辑合同信息' : '添加合同信息'" @opened="dialogOpended();" :visible.sync="dialogVisible">
      <el-form :model="form" ref="form" label-width="100px" :status-icon="true"
        @submit.native.prevent="submitForm('form')">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="项目" prop="projectID">
              <el-select v-model="form.projectID" filterable>
                <el-option v-for="item in reverseProject" :label="item.name" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="选择地址">
          <div id="uploadBtn3" class="uploader uploader-warning"></div>
        </el-form-item>

        <el-form-item label="合同名称" prop="title">
          <el-input v-model="form.title" placeholder="请输入合同名称" :rules="[{ required: true, message: '请输入文件名称' }]"></el-input>
        </el-form-item>

        <el-form-item label="上传地址" prop="fileUrl">
          <el-input id="relativeName" v-model="form.fileUrl" placeholder="请填写上传地址"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
export default {
  data() {
    return {
      domain: url.getDomain(),
      projectid: "",
      key: "",
      query: {}, //对象
      loading: false,
      currentPage4: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      projectlist: [],
      form: {}, //表单对象
      dialogVisible: false,
      submiting: false,
      id: 0
    };
  },
  computed: {
    reverseProject: function () {
      return this.projectlist.slice(0).reverse();
    }
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getList();
    },
    //筛选
    filterTag(filter) {
      var val = filter["isEnable"][0];
      this.form.isEnable = val;
      //刷新列表
      this.getList();
    },
    //排序
    sortChange(sortColumn) {
      this.form.sort = sortColumn.prop;
      this.form.order = sortColumn.order;
      //刷新列表
      this.getList();
    },
    //获取合同列表
    getList: function () {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      params.projectid = _this.projectid;
      params.key = _this.key;
      var link = url.getProject("getlist_contract");
      $.get(link, params, data => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    // 获取项目列表
    getProject: function () {
      var _this = this;
      var params = _this.query;
      params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      params.key = _this.key;
      var link = url.getProject("GetListAll");
      $.get(link, params, data => {
        _this.projectlist = data;

      });
    },
    //搜索查询
    selList: function () {
      this.currentPage4 = 1;
      this.getList();
    },
    //提交表单
    submitForm(formName) {
      var _this = this;
      var link = url.getProject("add_contract");
      var info = this.form;
      info.projectid = this.projectid;
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submiting = true;
          //提交后台添加
          //添加或者修改
          $.post(link, info, res => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    dialogOpended() {
      var _this = this;
      if ($("#uploadBtn3 input").length == 0) {
        $("#uploadBtn3").uploader({
          url: url.getUpload(),
          text: "上传文件",
          fileExts: "doc;docx;pdf",
          handleType: "0",
          debug: false,
          max: 1024 * 1204 * 10, //上传文件最大值
          onCheck: function (file) {
            var name = file.name.substring(0, file.name.lastIndexOf("."));
            _this.form.title = name;
            return true;
          },
          onSuccess: function (data) {
            var relativeName = data.relativeName;
            //解决其他js时间中的vue数据同步问题
            _this.$set(_this.form, "fileUrl", relativeName);
          }
        });
      }
    },
    //删除
    delClick: function (row) {
      var _this = this;
      var link = url.getProject("delete_contract"); //获取请求地址
      var id = row.id; //获取对象id

      this.$confirm("确定要删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          $.post(link, { id: id }, res => {
            _this.btnLoading = false;
            if (res.status) {
              _this.msg = res;
              _this.getList();
            }
          });
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  },
  // watch: {
  //   //路由监听
  //   $route: function (to, from) {
  //     this.projectid = this.$route.query.id;
  //     this.tableData = [];
  //     this.getList();
  //   }
  // },
  mounted() {
    var _this = this;
    //接收参数id
    _this.projectid = parseInt(_this.$route.query.id);
    _this.getProject();
    _this.getList();
  }
};
</script>

<style>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
</style>

